import { isMobile } from './isMobile';

export function mousePositionToIconColumnRow(element, mouseEvent) {
  const finalYPositions = isMobile() ? [0, 100, 200] : [0, 170, 340];
  const finalXPositions = isMobile() ? [0, 105, 210, 315, 420] : [276, 456, 636, 816, 996];

  const globalPoint = mouseEvent.data.global;
  const { tx, ty } = element.worldTransform;
  const containerX = globalPoint.x - tx;
  const containerY = globalPoint.y - ty;
  const iconHalfWidth = isMobile() ? 52 : 90;
  const iconHalfHeight = (isMobile() ? 100 : 170) / 2;
  const column = finalXPositions.findIndex(
    (columnCenter) =>
      containerX >= columnCenter - iconHalfWidth && containerX <= columnCenter + iconHalfWidth
  );
  const row = finalYPositions.findIndex(
    (rowCenter) =>
      containerY >= rowCenter - iconHalfHeight && containerY <= rowCenter + iconHalfHeight
  );
  if (column > -1 && row > -1) {
    return { column, row };
  }
  return null;
}
